export const isChrome =
  typeof navigator !== 'undefined' && navigator.userAgent.includes('Chrome/');
export const isFirefox =
  typeof navigator !== 'undefined' && navigator.userAgent.includes('Gecko/');
export const isSafari =
  typeof navigator !== 'undefined' &&
  navigator.userAgent.includes('Safari/') &&
  navigator.userAgent.includes('AppleWebKit/') &&
  !isChrome;
